/* eslint-disable no-undef */
import { Controller } from 'stimulus';

export default class BeaconLink extends Controller {
  open(e) {
    e.preventDefault();

    if (this.element.getAttribute('data-beacon-subject')) {
      Beacon('prefill', {
        subject: this.element.getAttribute('data-beacon-subject')
      });
    }
    Beacon('navigate', '/ask/message');
    Beacon('open');
  }

  openAnswers(e) {
    e.preventDefault();

    Beacon('navigate', '/answers');
    Beacon('open');
  }

}
